import { Box, Tag } from '@factorialco/deprecated-design-system'
import { DetailsItemsList } from '@factorialco/factorial-one-react/dist/experimental'
import { AtsCandidateSideContentFragment } from 'generated/resources/graphql'
import capitalize from 'lodash/capitalize'

import { dateBackendDateTimeToUI } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import { CandidateTags } from 'modules/ats/components/CandidateTags'
import { timeAgoWhenRecent } from 'modules/ats/lib/dates'
import { isConsentExpired } from 'modules/ats/lib/utils/candidate'
import { getSourceLabel } from 'modules/ats/lib/utils/candidateSources'
import { getGenderLabel } from 'modules/ats/lib/utils/gender'

interface Props {
  data: AtsCandidateSideContentFragment
}
export const CandidateSideContent: React.FC<Props> = ({ data }) => {
  const { createdAt, candidateSource, consentExpirationDate, gender, talentPool } = data

  const consentText = consentExpirationDate
    ? isConsentExpired(consentExpirationDate)
      ? i18n.t('ats.candidate_details.side_content.data_consent.consent_expired_on', {
          date: dateBackendDateTimeToUI(consentExpirationDate),
        })
      : i18n.t('ats.candidate_details.side_content.data_consent.consent_given')
    : i18n.t('ats.candidate_details.side_content.data_consent.no_consent')

  return (
    <Box gap="s24">
      <Box>
        <DetailsItemsList
          title={i18n.t('ats.candidate_details.side_content.personal_info_title')}
          details={[
            {
              title: i18n.t('ats.candidate_details.side_content.gender_label'),
              content: {
                type: 'item',
                text: getGenderLabel(gender),
              },
            },
            {
              title: i18n.t('ats.candidate_details.side_content.talent_pool'),
              content: {
                type: 'item',
                text: talentPool
                  ? capitalize(i18n.t('common.yes'))
                  : capitalize(i18n.t('common.no')),
              },
            },
            {
              title: i18n.t('ats.candidate_details.side_content.added_label'),
              content: {
                type: 'item',
                text: timeAgoWhenRecent(createdAt),
              },
            },
            {
              title: i18n.t('ats.candidate_details.side_content.consent_label'),
              content: {
                type: 'item',
                text: consentText,
              },
            },
            {
              title: i18n.t('ats.candidate_details.side_content.source_label'),
              content: {
                type: 'item',
                text: '',
              },
            },
          ]}
        />
        {/* TO DO: temporary layout solution to no block the Revamp task
         * We need to find out a component or ask Foundations to add it to the DetailsItemsList
         */}

        <Box alignItems="flexStart" paddingLeft="s6">
          <Tag type={candidateSource?.name === 'referred' ? 'radical' : 'viridian'} inline>
            {getSourceLabel(candidateSource?.name || '')}
          </Tag>
        </Box>
      </Box>

      {/* TO DO: temporary layout solution to no block the Revamp task
       * We need to find out a component or ask Foundations to add it to the DetailsItemsList
       */}
      <Box>
        <DetailsItemsList
          title={i18n.t('ats.candidate_details.side_content.tags_title')}
          details={[]}
        />
        <Box paddingLeft="s6">
          <CandidateTags candidate={data} source="Candidate" />
        </Box>
      </Box>
    </Box>
  )
}
